import { useState } from "react";

interface PasswordInputProps {
  id?: string;
  name?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoComplete?: string;
}

export default function PasswordInput({
  id,
  name,
  value,
  onChange,
  placeholder,
  autoComplete,
}: PasswordInputProps) {
  const [show, setShow] = useState(false);

  return (
    <div className="relative">
      <input
        id={id}
        name={name}
        type={show ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className="w-full px-4 py-3 pr-11 rounded-md border border-background-300/60 bg-background-50 text-sm text-foreground-900 font-body focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 placeholder:text-foreground-400"
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
        className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-800 cursor-pointer transition-colors"
      >
        <i className={show ? "ri-eye-off-line" : "ri-eye-line"} />
      </button>
    </div>
  );
}